import { Container, Divider, Grid, Typography, Box, Chip } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";
import IconButton from "@mui/material/IconButton";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import FacebookIcon from "@mui/icons-material/Facebook";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import InstagramIcon from "@mui/icons-material/Instagram";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import SecurityIcon from "@mui/icons-material/Security";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import AssignmentReturnIcon from "@mui/icons-material/AssignmentReturn";
import DescriptionIcon from "@mui/icons-material/Description";

const AppFooter = () => {
  return (
    <Box
      component="footer"
      sx={{
        background: "linear-gradient(135deg, #075e54 0%,rgb(7, 137, 122) 100%)",
        color: "white",
        mt: "4rem",
        position: "relative",
        overflow: "hidden",
        "&::before": {
          content: '""',
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background:
            'url(\'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 20"><defs><radialGradient id="a" cx="50%" cy="50%" r="50%"><stop offset="0%" stop-color="%23ffffff" stop-opacity="0.1"/><stop offset="100%" stop-color="%23ffffff" stop-opacity="0"/></radialGradient></defs><rect width="100" height="20" fill="url(%23a)"/></svg>\') repeat',
          opacity: 0.1,
          zIndex: 0,
        },
      }}
    >
      {/* Wave decoration */}
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          overflow: "hidden",
          lineHeight: 0,
          transform: "rotate(180deg)",
        }}
      >
        <svg
          viewBox="0 0 1200 120"
          preserveAspectRatio="none"
          style={{
            position: "relative",
            display: "block",
            width: "100%",
            height: "60px",
          }}
        >
          <path
            d="M985.66,92.83C906.67,72,823.78,31,743.84,14.19c-82.26-17.34-168.06-16.33-250.45.39-57.84,11.73-114,31.07-172,41.86A600.21,600.21,0,0,1,0,27.35V120H1200V95.8C1132.19,118.92,1055.71,111.31,985.66,92.83Z"
            fill="white"
          />
        </svg>
      </Box>

      <Container
        maxWidth="lg"
        sx={{ position: "relative", zIndex: 1, pt: "5rem", pb: "3rem" }}
      >
        <Grid container spacing={4}>
          {/* Company Info Section */}
          <Grid item xs={12} md={4}>
            <Box sx={{ mb: 3 }}>
              <Typography
                variant="h4"
                sx={{
                  fontWeight: "bold",
                  mb: 2,
                  background: "linear-gradient(45deg, #fff, #e3f2fd)",
                  backgroundClip: "text",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                }}
              >
                Apeksha Lifecare Products
              </Typography>
              <Typography
                variant="body1"
                sx={{ mb: 3, opacity: 0.9, lineHeight: 1.6 }}
              >
                Your trusted partner for quality healthcare products. We are
                committed to improving lives through innovative and reliable
                health solutions.
              </Typography>
              <Chip
                icon={
                  <SecurityIcon
                    sx={{ fontSize: 20, color: "white !important" }}
                  />
                }
                label="Trusted Since 2020"
                sx={{
                  color: "white",
                  border: "1px solid rgba(255, 255, 255, 0.79)",
                  "& .MuiChip-icon": {
                    color: "white !important",
                  },
                }}
              />
            </Box>
          </Grid>

          {/* Quick Links */}
          <Grid item xs={12} sm={6} md={2}>
            <Typography
              variant="h6"
              sx={{
                fontWeight: "bold",
                mb: 3,
                position: "relative",
                "&::after": {
                  content: '""',
                  position: "absolute",
                  bottom: "-8px",
                  left: 0,
                  width: "30px",
                  height: "3px",
                  background:
                    "linear-gradient(45deg, rgb(8, 166, 148), rgb(12, 187, 166))",
                  borderRadius: "2px",
                },
              }}
            >
              Policies
            </Typography>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
              {[
                {
                  icon: <SecurityIcon />,
                  text: "Privacy Policy",
                  link: "/privacy-policy",
                },
                {
                  icon: <AssignmentReturnIcon />,
                  text: "Refund Policy",
                  link: "/refund-policy",
                },
                {
                  icon: <LocalShippingIcon />,
                  text: "Shipping Policy",
                  link: "/shipping-policy",
                },
                {
                  icon: <DescriptionIcon />,
                  text: "Terms & Conditions",
                  link: "/terms-and-conditions",
                },
              ].map((item, index) => (
                <Link
                  key={index}
                  to={item.link}
                  style={{
                    textDecoration: "none",
                    color: "inherit",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    padding: "8px 0",
                    transition: "all 0.3s ease",
                    borderRadius: "4px",
                  }}
                  onMouseEnter={(e) => {
                    const textElement =
                      e.currentTarget.querySelector(".policy-text");
                    if (textElement) {
                      textElement.style.transform = "translateX(5px)";
                      // textElement.style.color = "rgb(126, 255, 240)";
                    }
                  }}
                  onMouseLeave={(e) => {
                    const textElement =
                      e.currentTarget.querySelector(".policy-text");
                    if (textElement) {
                      textElement.style.transform = "translateX(0)";
                      textElement.style.color = "inherit";
                    }
                  }}
                >
                  <Box
                    sx={{
                      fontSize: "16px",
                      opacity: 0.8,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      minWidth: "20px",
                      height: "20px",
                    }}
                  >
                    {item.icon}
                  </Box>
                  <Typography
                    variant="body2"
                    className="policy-text"
                    sx={{
                      transition: "all 0.3s ease",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    {item.text}
                  </Typography>
                </Link>
              ))}
            </Box>
          </Grid>

          {/* Contact Information */}
          <Grid item xs={12} sm={6} md={3}>
            <Typography
              variant="h6"
              sx={{
                fontWeight: "bold",
                mb: 3,
                position: "relative",
                "&::after": {
                  content: '""',
                  position: "absolute",
                  bottom: "-8px",
                  left: 0,
                  width: "30px",
                  height: "3px",
                  background:
                    "linear-gradient(45deg, rgb(8, 166, 148), rgb(12, 187, 166))",
                  borderRadius: "2px",
                },
              }}
            >
              Contact Us
            </Typography>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
              <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1 }}>
                <LocationOnIcon sx={{ fontSize: 20, mt: 0.5 }} />
                <Typography variant="body2" sx={{ lineHeight: 1.6 }}>
                  1st, 276, Bhagirathi Vihar colony,
                  <br />
                  Noorpur Panjanhedi, Haridwar, UT, 249408
                </Typography>
              </Box>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <EmailIcon sx={{ fontSize: 20 }} />
                <Typography
                  component="a"
                  href="mailto:inproveda@gmail.com"
                  variant="body2"
                  sx={{
                    color: "inherit",
                    textDecoration: "none",
                    transition: "all 0.3s ease",
                    "&:hover": {
                      color: "rgb(126, 255, 240)",
                      textDecoration: "underline",
                    },
                  }}
                >
                  inproveda@gmail.com
                </Typography>
              </Box>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <PhoneIcon sx={{ fontSize: 20 }} />
                <Typography
                  component="a"
                  href="tel:+919411174186"
                  variant="body2"
                  sx={{
                    color: "inherit",
                    textDecoration: "none",
                    transition: "all 0.3s ease",
                    "&:hover": {
                      color: "rgb(126, 255, 240)",
                      textDecoration: "underline",
                    },
                  }}
                >
                  +91-9411174186
                </Typography>
              </Box>
            </Box>
          </Grid>

          {/* Social Media */}
          <Grid item xs={12} md={3}>
            <Typography
              variant="h6"
              sx={{
                fontWeight: "bold",
                mb: 3,
                position: "relative",
                "&::after": {
                  content: '""',
                  position: "absolute",
                  bottom: "-8px",
                  left: 0,
                  width: "30px",
                  height: "3px",
                  background:
                    "linear-gradient(45deg, rgb(8, 166, 148), rgb(12, 187, 166))",
                  borderRadius: "2px",
                },
              }}
            >
              Follow Us
            </Typography>
            <Typography variant="body2" sx={{ mb: 3, opacity: 0.9 }}>
              Stay connected with us on social media for updates and health
              tips.
            </Typography>
            <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
              {[
                {
                  icon: <FacebookIcon sx={{ fontSize: 28 }} />,

                  href: "https://www.facebook.com/profile.php?id=61559031269996",
                  color: "#1877f2",
                  label: "Facebook",
                },
                {
                  icon: <InstagramIcon sx={{ fontSize: 28 }} />,
                  href: "https://www.instagram.com/inprovedahealthcare/",
                  color: "#e4405f",
                  label: "Instagram",
                },
                {
                  icon: <LinkedInIcon sx={{ fontSize: 28 }} />,
                  href: "https://www.linkedin.com/in/inprovedahealthcare-products-b36a6037/",
                  color: "#0077b5",
                  label: "LinkedIn",
                },
                {
                  icon: <WhatsAppIcon sx={{ fontSize: 28 }} />,
                  href: "https://api.whatsapp.com/send/?phone=919411174186",
                  color: "#25d366",
                  label: "WhatsApp",
                },
              ].map((social, index) => (
                <IconButton
                  key={index}
                  component="a"
                  href={social.href}
                  target="_blank"
                  rel="nofollow"
                  aria-label={social.label}
                  sx={{
                    width: 48,
                    height: 48,
                    borderRadius: "50%",
                    background: "transparent",
                    color: "white",
                    border: "none",
                    transition: "all 0.5s cubic-bezier(0.5, 0, 0.2, 1)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: 28,
                    "&:hover": {
                      background: "transparent",
                      color: social.color,
                      transform: "translateY(-3px) ",
                      boxShadow: "none",
                    },
                  }}
                >
                  {social.icon}
                </IconButton>
              ))}
            </Box>
          </Grid>
        </Grid>

        {/* Bottom Section */}
        <Divider sx={{ my: 4, borderColor: "rgba(255,255,255,0.2)" }} />
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} md={6}>
            <Typography variant="body2" sx={{ opacity: 0.8 }}>
              © {new Date().getFullYear()} Apeksha Lifecare Products. All rights
              reserved.
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
            sx={{ textAlign: { xs: "left", md: "right" } }}
          >
            <Typography variant="body2" sx={{ opacity: 0.8 }}>
              Webapp developed by{" "}
              <a
                href="https://softaim.in"
                target="_blank"
                rel="external"
                style={{
                  color: "#64b5f6",
                  textDecoration: "none",
                  fontWeight: "500",
                  transition: "all 0.3s ease",
                }}
                onMouseEnter={(e) => {
                  e.target.style.color = "#42a5f5";
                  e.target.style.textDecoration = "underline";
                }}
                onMouseLeave={(e) => {
                  e.target.style.color = "#64b5f6";
                  e.target.style.textDecoration = "none";
                }}
              >
                Softaim Technologies Pvt. Ltd.
              </a>
            </Typography>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default AppFooter;
